import Icon from '../components/Icon.vue'

Icon.register({"step-backward":{"width":1024,"height":1792,"paths":[{"d":"M979 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v678q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h128q26 0 45 19t19 45v678q4-10 13-19z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/step-backward.js
// module id = 1857
// module chunks = 0